<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">Create new record</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="create-record-content">

    @for (date of dates; track date; let index = $index; let first = $first; let last = $last) {

      <!-- Title -->
      <div class="row">
        <div class="title">Title</div>
        <input class="input" [(ngModel)]="date.title">
      </div>

      <!-- Date -->
      <div class="line">
        <!-- Date -->
        <div class="row">
          @if (first) {
            <div class="title">Start Date</div>
          }
          <input class="input date-input" [matDatepicker]="picker" [min]="minDate" [value]="date.startTime" (dateChange)="updateDate($event, index)"  (focus)="picker.open()" placeholder="Select...">
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="divider"></div>
        <!-- Time -->
        <div class="row">
          @if (first) {
            <div class="title">Time</div>
          }
          <input class="input time-input" appTimeMask [(ngModel)]="date.startTime">
        </div>
        <div class="row">
          @if (first) {
            <div class="title">Time Zone</div>
          }
          <app-select class="select" [options]="recordOptions.timezones" [selected]="date.timezone" (selectedChange)="updateTimezone($event, index)"></app-select>
        </div>
        <div class="row">
          @if (first) {
            <div class="title"></div>
          }
          <div class="button-create date">
            @if (last) {
              <mat-icon svgIcon="plus" class="icon" (click)="addExtraDate()"></mat-icon>
            }
            @else {
              <mat-icon svgIcon="trash" class="icon" (click)="deleteExtraDate(index)"></mat-icon>
            }
          </div>
        </div>
      </div>
    }

    <!-- Duration -->
    @if (project?.startTrigger?.type === 'startTime') {
      <div class="line">
        <div class="row">
          <div class="title">Duration</div>
          <app-select class="select" [options]="recordOptions.duration" [selected]="record.durationType" (selectedChange)="updateDuration($event)"></app-select>
        </div>
        <div class="divider"></div>
        <div class="row">
          <div class="title">Value</div>
          @if (record.durationType === 'seconds') {
            <input class="input" type="number" min="0" [(ngModel)]="durationMinutes">
          } @else {
            <input class="input" [(ngModel)]="record.durationValue">
          }
        </div>
      </div>
    }

    <!-- VOD -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.vod) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>VOD Metadata</div>
        </div>
        @for (metadata of recordMetadata.vod; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }
    <!-- MAX -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.max) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>MAX Metadata</div>
        </div>
        @for (metadata of recordMetadata.max; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }
    <!-- Linear -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.linear) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>Linear Metadata</div>
        </div>
        @for (metadata of recordMetadata.linear; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }
    <!-- Content Acquisition -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.contentAcquisition) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>Content Acquisition Metadata</div>
        </div>
        @for (metadata of recordMetadata.contentAcquisition; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }
    <!-- Archive -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.archive) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>Archive Metadata</div>
        </div>
        @for (metadata of recordMetadata.archive; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }
    <!-- C3 -->
    @if ((permissions | includesBy: 'record:update') && metadataTasks.c3) {
      <div class="row" [class.disabled]="!(permissions | includesBy: 'record:update')">
        <div class="title">
          <div>C3 Metadata</div>
        </div>
        @for (metadata of recordMetadata.c3; track metadata; let index = $index) {
          <div class="metadata">
            <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
            <input class="input" [(ngModel)]="metadata.value">
          </div>
        }
      </div>
    }

    <!-- S3 Download -->
    @if (metadataTasks.s3Download) {
      <div class="row">
        <div class="title">
          <div>S3 Download Metadata</div>
        </div>
      </div>
      @for (metadata of recordMetadata.s3Download; track metadata; let index = $index) {
        <div class="metadata">
          <input class="input static" [ngModel]="getDisplayKey(metadata.key)">
          <input class="input" [(ngModel)]="metadata.value">
        </div>
      }
    }

  </div>

  @if (error) {
    <div class="message error">{{ error }}</div>
  }
</div>
  
<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  <div class="button secondary" (click)="close()">Cancel</div>
  <div class="button" (click)="create()">{{ isEdit ? 'Save' : 'Create' }}</div>
</div>
  